import React from 'react';
import * as S from './AlternateDates.styles';
import Shimmer from '../../../../components/Shimmer/Shimmer';

const AlternateDatesCardLoading = () => {
  return (
    <>
      <S.PropertyAvailableText>
        <Shimmer
          width={'200px'}
          height={'20px'}
          radius={'2px'}
          shimmerColor={
            'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
          }
          customStyle={{
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            display: 'flex',
            marginLeft: 'auto',
          }}
          data-testid="alternate-dates-loading"
        />
      </S.PropertyAvailableText>
      <S.AvailableDateList>
        {Array(4)
          .fill(0)
          .map((_, index) => (
            <S.AlternateDateCardLoading key={index.toString()}>
              <Shimmer
                width={'117px'}
                height={'12px'}
                radius={'2px'}
                marginTop={'13px'}
                marginBottom={'13px'}
                shimmerColor={
                  'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
                }
                customStyle={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                }}
              />
              <Shimmer
                width={'90px'}
                height={'12px'}
                radius={'2px'}
                marginTop={'13px'}
                marginBottom={'10px'}
                shimmerColor={
                  'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)'
                }
                customStyle={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                }}
              />
            </S.AlternateDateCardLoading>
          ))}
      </S.AvailableDateList>
    </>
  );
};

export default AlternateDatesCardLoading;
